import { useEffect, useState } from 'react';
import { collection } from 'firebase/firestore';
import { safeOnSnapshot } from '../../../utils/firestoreSubscriptions';
import { db } from '../../../firebase-client';
import { isWaitlistedStatus, sortWaitlistMembers } from '../../../utils/waitlist';

export function useWaitlistMembers(id, enabled = true) {
  const [waitlistMembers, setWaitlistMembers] = useState([]);

  useEffect(() => {
    if (!id || !enabled) {
      setWaitlistMembers([]);
      return;
    }

    const unsub = safeOnSnapshot(
      collection(db, 'teams', id, 'pendingMembers'),
      (qs) => {
        const items = qs.docs
          .map((docSnap) => ({
            id: docSnap.id,
            ...docSnap.data(),
          }))
          .filter((member) => isWaitlistedStatus(member.status));
        setWaitlistMembers(sortWaitlistMembers(items));
      },
      (err) => {
        if (err?.code === 'permission-denied') return;
      }
    );

    return () => unsub();
  }, [id, enabled]);

  return waitlistMembers;
}
